import React from 'react'
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Cell,
} from 'recharts'
import { Box, Typography } from '@mui/material'

interface ChartDataItem {
  name: string
  shortCode: string
  value: number
  color: string
}

interface CustomBarChartProps {
  data: ChartDataItem[]
  chartColors: string[]
}

interface TooltipProps {
  active?: boolean
  payload?: Array<{ payload: ChartDataItem; value: number }>
}

const CustomTooltip = ({ active, payload }: TooltipProps) => {
  if (active && payload && payload.length) {
    return (
      <Box
        sx={{
          backgroundColor: 'white',
          border: '1px solid #ccc',
          padding: '10px',
          borderRadius: '4px',
          boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
        }}
      >
        <Typography variant='body2' sx={{ fontWeight: 'bold' }}>
          {payload[0].payload.name}
        </Typography>
        <Typography variant='body2' sx={{ color: '#666' }}>
          Fjöldi: {payload[0].value}
        </Typography>
      </Box>
    )
  }
  return null
}

export function CustomBarChart({ data, chartColors }: CustomBarChartProps) {
  return (
    <Box sx={{ height: 300, width: '100%' }}>
      <ResponsiveContainer width='100%' height='100%'>
        <BarChart
          data={data}
          margin={{
            top: 20,
            right: 30,
            left: 20,
          }}
        >
          <XAxis
            dataKey='shortCode'
            angle={0}
            textAnchor='middle'
            height={30}
            interval={0}
            tick={{ fontSize: 12 }}
          />
          <YAxis
            label={{
              value: 'Fjöldi skráninga á tímabili',
              angle: -90,
              position: 'insideLeft',
              offset: -10,
              style: { textAnchor: 'middle' },
            }}
          />
          <Tooltip
            content={<CustomTooltip />}
            cursor={{ fill: 'rgba(0, 0, 0, 0.05)' }}
            animationDuration={0} // This disables the slide-in animation
          />
          <Bar
            dataKey='value'
            name='Fjöldi'
            radius={[4, 4, 0, 0]}
            isAnimationActive={false} // This disables bar animations
          >
            {data.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={chartColors[index % chartColors.length]}
              />
            ))}
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </Box>
  )
}
